/* BWY Stockists locator. Paired with sections/bwy-stockists.liquid.
   Store lists and postcode/suburb centroids are static JSON assets; nothing
   here calls a third-party API except the keyless Google Maps embed. */
(function () {
  'use strict';

  var FAR_KM = 50;
  var STATE_ORDER = ['NSW', 'VIC', 'QLD', 'WA', 'SA', 'ACT', 'TAS', 'NT'];
  var jsonCache = {};

  function getJSON(url) {
    if (!jsonCache[url]) {
      jsonCache[url] = fetch(url).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
      jsonCache[url].catch(function () { delete jsonCache[url]; });
    }
    return jsonCache[url];
  }

  function km(aLat, aLng, bLat, bLng) {
    var R = 6371, toRad = Math.PI / 180;
    var dLat = (bLat - aLat) * toRad, dLng = (bLng - aLng) * toRad;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(aLat * toRad) * Math.cos(bLat * toRad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fill(tpl, vars) {
    return tpl.replace(/\{(\w+)\}/g, function (m, k) { return k in vars ? vars[k] : m; });
  }

  function Locator(root) {
    this.root = root;
    this.cfg = JSON.parse(root.querySelector('[data-config]').textContent);
    this.L = this.cfg.labels;
    this.pageSize = this.cfg.pageSize || 10;
    this.el = {
      form: root.querySelector('[data-search-form]'),
      input: root.querySelector('[data-search-input]'),
      locate: root.querySelector('[data-locate]'),
      states: root.querySelector('[data-states]'),
      filters: root.querySelector('[data-filters]'),
      status: root.querySelector('[data-status]'),
      results: root.querySelector('[data-results]'),
      more: root.querySelector('[data-more]'),
      map: root.querySelector('[data-map]')
    };
    this.stores = [];
    this.list = [];
    this.shown = 0;
    this.activeRetailers = null;
    this.bind();
    this.ready = this.load();
  }

  Locator.prototype.load = function () {
    var self = this;
    return Promise.all(this.cfg.retailers.map(function (r) {
      return getJSON(r.data).then(function (d) {
        return d.stores.map(function (s) { s.r = r.name; return s; });
      });
    })).then(function (lists) {
      self.stores = [].concat.apply([], lists);
      self.renderStates();
      self.renderFilters();
    }).catch(function () {
      self.status(self.L.error);
      throw new Error('stockists: store list failed');
    });
  };

  Locator.prototype.bind = function () {
    var self = this;
    this.el.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.search(self.el.input.value);
    });
    this.el.locate.addEventListener('click', function () { self.locate(); });
    this.el.more.addEventListener('click', function () { self.renderMore(); });
    this.el.results.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      var li = e.target.closest('[data-store]');
      if (li) self.select(li.getAttribute('data-store'));
    });
    this.el.results.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[data-store]')) {
        e.preventDefault();
        self.select(e.target.getAttribute('data-store'));
      }
    });
  };

  Locator.prototype.status = function (msg, link) {
    this.el.status.textContent = msg;
    if (link && link.url && link.label) {
      var a = document.createElement('a');
      a.className = 'bwy-stockists__status-link';
      a.href = link.url;
      a.textContent = link.label;
      this.el.status.appendChild(document.createTextNode(' '));
      this.el.status.appendChild(a);
    }
  };

  Locator.prototype.pool = function () {
    var active = this.activeRetailers;
    return active ? this.stores.filter(function (s) { return active[s.r]; }) : this.stores;
  };

  /* Resolve a query to coordinates: four-digit postcode first, then a store
     in that town, then any Australian suburb. */
  Locator.prototype.geocode = function (q) {
    var self = this;
    var clean = q.trim();
    if (/^\d{4}$/.test(clean)) {
      return getJSON(this.cfg.postcodes).then(function (pc) {
        var hit = pc[clean];
        return hit ? { lat: hit[0], lng: hit[1], label: clean } : null;
      });
    }
    var parts = clean.toUpperCase().replace(/[,]+/g, ' ').replace(/\s+/g, ' ').trim();
    var stateMatch = parts.match(/\s(NSW|VIC|QLD|WA|SA|ACT|TAS|NT)$/);
    var state = stateMatch ? stateMatch[1] : null;
    var name = state ? parts.slice(0, -state.length).trim() : parts;
    var pcInText = name.match(/\b(\d{4})\b/);
    if (pcInText) return this.geocode(pcInText[1]);
    if (!name) return Promise.resolve(null);

    var townHit = this.stores.filter(function (s) {
      return s.t.toUpperCase() === name && (!state || s.s === state);
    })[0];
    if (townHit) return Promise.resolve({ lat: townHit.la, lng: townHit.lo, label: townHit.t });

    return getJSON(this.cfg.localities).then(function (loc) {
      var key, hit = null;
      if (state && loc[name + '|' + state]) hit = loc[name + '|' + state];
      if (!hit) {
        for (var i = 0; i < STATE_ORDER.length && !hit; i++) {
          key = name + '|' + STATE_ORDER[i];
          if (loc[key]) hit = loc[key];
        }
      }
      if (!hit && name.length >= 3) {
        for (key in loc) {
          if (key.indexOf(name) === 0) { hit = loc[key]; break; }
        }
      }
      return hit ? { lat: hit[0], lng: hit[1], label: self.titleCase(name) } : null;
    });
  };

  Locator.prototype.titleCase = function (s) {
    return s.toLowerCase().replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  };

  Locator.prototype.search = function (q) {
    var self = this;
    if (!q || !q.trim()) { this.el.input.focus(); return; }
    this.setActiveState(null);
    this.status(this.L.searching);
    this.ready.then(function () {
      return self.geocode(q);
    }).then(function (pt) {
      if (!pt) {
        self.clear();
        self.status(self.L.notFound);
        return;
      }
      self.showNearest(pt.lat, pt.lng, pt.label);
    }).catch(function () {
      self.status(self.L.error);
    });
  };

  Locator.prototype.locate = function () {
    var self = this;
    if (!navigator.geolocation) { this.status(this.L.geoDenied); return; }
    this.setActiveState(null);
    this.status(this.L.searching);
    navigator.geolocation.getCurrentPosition(function (pos) {
      self.ready.then(function () {
        self.el.input.value = '';
        self.showNearest(pos.coords.latitude, pos.coords.longitude, 'you');
      });
    }, function () {
      self.status(self.L.geoDenied);
    }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 });
  };

  Locator.prototype.showNearest = function (lat, lng, label) {
    var list = this.pool().map(function (s) {
      return { s: s, d: km(lat, lng, s.la, s.lo) };
    }).sort(function (a, b) { return a.d - b.d; });
    this.list = list;
    if (list.length && list[0].d > FAR_KM) {
      this.status(this.L.far, { label: this.L.farLink, url: this.L.farUrl });
    } else {
      this.status(fill(this.L.results, { place: label }));
    }
    this.renderList();
    if (list.length) this.select(list[0].s.id, true);
  };

  Locator.prototype.showState = function (state) {
    var list = this.pool().filter(function (s) { return s.s === state; })
      .sort(function (a, b) { return a.t.localeCompare(b.t) || a.n.localeCompare(b.n); })
      .map(function (s) { return { s: s, d: null }; });
    this.list = list;
    this.el.input.value = '';
    this.status(fill(this.L.state, { count: list.length, state: state }));
    this.renderList();
  };

  Locator.prototype.clear = function () {
    this.list = [];
    this.renderList();
  };

  Locator.prototype.renderList = function () {
    this.el.results.innerHTML = '';
    this.shown = 0;
    this.root.querySelector('.bwy-stockists__locator').classList.toggle('has-results', this.list.length > 0);
    this.renderMore();
  };

  Locator.prototype.renderMore = function () {
    var slice = this.list.slice(this.shown, this.shown + this.pageSize);
    var html = slice.map(this.card, this).join('');
    this.el.results.insertAdjacentHTML('beforeend', html);
    this.shown += slice.length;
    this.el.more.hidden = this.shown >= this.list.length;
  };

  Locator.prototype.card = function (item) {
    var s = item.s, L = this.L;
    var today = s.h && s.h[(new Date().getDay() + 6) % 7];
    var hours = s.h && s.h.length ? (today ? L.today + ' ' + today : L.closedToday) : '';
    var dist = item.d == null ? '' : '<span class="bwy-st-card__dist">' + (item.d < 10 ? item.d.toFixed(1) : Math.round(item.d)) + ' km</span>';
    var dir = 'https://www.google.com/maps/dir/?api=1&destination=' + s.la + ',' + s.lo;
    return '<li class="bwy-st-card" data-store="' + esc(s.id) + '" tabindex="0">' +
      '<div class="bwy-st-card__top"><h3 class="bwy-st-card__name">' + esc(s.n) + '</h3>' + dist + '</div>' +
      '<p class="bwy-st-card__addr">' + esc(s.a) + '<br>' + esc(s.t) + ' ' + esc(s.s) + ' ' + esc(s.p) + '</p>' +
      (hours ? '<p class="bwy-st-card__hours">' + esc(hours) + '</p>' : '') +
      '<p class="bwy-st-card__links">' +
        (s.ph ? '<a href="tel:' + esc(s.ph.replace(/\s+/g, '')) + '">' + esc(s.ph) + '</a>' : '') +
        '<a href="' + esc(dir) + '" target="_blank" rel="noopener">' + esc(L.directions) + '</a>' +
        (s.u ? '<a href="' + esc(s.u) + '" target="_blank" rel="noopener">' + esc(L.storePage) + '</a>' : '') +
      '</p></li>';
  };

  Locator.prototype.select = function (id, quiet) {
    var store = this.stores.filter(function (s) { return s.id === id; })[0];
    if (!store) return;
    var cards = this.el.results.querySelectorAll('[data-store]');
    for (var i = 0; i < cards.length; i++) {
      var on = cards[i].getAttribute('data-store') === id;
      cards[i].classList.toggle('is-active', on);
      cards[i].setAttribute('aria-current', on ? 'true' : 'false');
    }
    /* Coordinates alone render without a pin, so search the address and
       anchor the view on the coordinates to keep Google on the right store. */
    var q = [store.n, store.a, store.t + ' ' + store.s + ' ' + store.p].join(', ');
    this.el.map.src = 'https://maps.google.com/maps?q=' + encodeURIComponent(q) +
      '&ll=' + store.la + ',' + store.lo + '&z=16&output=embed';
    this.el.map.title = 'Map of ' + store.n;
    if (!quiet && window.matchMedia('(max-width: 767px)').matches) {
      this.el.map.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  Locator.prototype.renderStates = function () {
    var self = this;
    var present = {};
    this.stores.forEach(function (s) { present[s.s] = true; });
    this.el.states.innerHTML = STATE_ORDER.filter(function (st) { return present[st]; }).map(function (st) {
      return '<button type="button" class="bwy-stockists__chip" data-state="' + st + '" aria-pressed="false">' + st + '</button>';
    }).join('');
    this.el.states.addEventListener('click', function (e) {
      var b = e.target.closest('[data-state]');
      if (!b) return;
      var st = b.getAttribute('data-state');
      self.setActiveState(st);
      self.showState(st);
    });
  };

  Locator.prototype.setActiveState = function (st) {
    var chips = this.el.states.querySelectorAll('[data-state]');
    for (var i = 0; i < chips.length; i++) {
      chips[i].setAttribute('aria-pressed', chips[i].getAttribute('data-state') === st ? 'true' : 'false');
    }
    this.activeState = st;
  };

  /* Only rendered when the section has more than one retailer with stores. */
  Locator.prototype.renderFilters = function () {
    var self = this;
    if (!this.el.filters) return;
    var names = this.cfg.retailers.map(function (r) { return r.name; });
    this.el.filters.innerHTML = names.map(function (n) {
      return '<label class="bwy-stockists__filter"><input type="checkbox" value="' + esc(n) + '" checked> ' + esc(n) + '</label>';
    }).join('');
    this.el.filters.addEventListener('change', function () {
      var active = {}, any = false;
      self.el.filters.querySelectorAll('input:checked').forEach(function (i) { active[i.value] = true; any = true; });
      self.activeRetailers = any ? active : null;
      if (self.activeState) self.showState(self.activeState);
      else if (self.el.input.value.trim()) self.search(self.el.input.value);
    });
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-bwy-stockists]').forEach(function (root) {
      if (root.__bwyStockists) return;
      root.__bwyStockists = new Locator(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
